import React, { ChangeEvent, useState, useContext, useEffect } from "react";
import * as _ from "lodash-es";
import "./VendorUserFilter.scss";
import OwButton from "../../../shared/OwButton/OwButton";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import OwInputWrapper from "../../../shared/OwInputWrapper/OwInputWrapper";
import SupplierContext from "../../../../contexts/SupplierContext";

type Props = {
    searchFn: (queryString?: string) => void;
};

export const VendorUserFilter: React.FC<Props> = (props) => {
    const [searchValues, setSearchValues] = useState({ name: "", vendor: "", email: "" });

    const supplierModel = useContext(SupplierContext);

    const getQuery = (): string[] => {
        const query: string[] = [];

        if (searchValues.name.length) {
            query.push(`vendor_user=${searchValues.name}`);
        }

        if (searchValues.vendor.length) {
            query.push(`vendor_name=${searchValues.vendor}`);
        }

        if (searchValues.email.length) {
            query.push(`vendor_user_email=${searchValues.email}`);
        }

        return query;
    };

    const performSearch = () => {
        const query = getQuery();

        let queryString = "";

        if (query.length) {
            queryString = "?";

            queryString += query.join("&");
        }

        props.searchFn(queryString);
    };

    const handleChange = (e: ChangeEvent<any>) => {
        const name = e.target.name;
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;

        switch (name) {
            case "name":
                setSearchValues({ ...searchValues, name: value });
                break;

            case "vendor":
                setSearchValues({ ...searchValues, vendor: value });
                break;

            case "email":
                setSearchValues({ ...searchValues, email: value });
                break;
        }
    };

    const enterSearch = (e: any) => {
        if (e.key === "Enter") {
            performSearch();
        }
    };

    useEffect(() => {
        if (!searchValues.name.length && !searchValues.email.length && !searchValues.vendor.length) {
            performSearch();
        }
    }, [searchValues]);

    const resetSearch = (e: any) => {
        setSearchValues({ name: "", vendor: "", email: "" });
    };

    return (
        <div className={"VendorUserFilter row d-flex align-items-end mb-2 mt-2"}>
            <div className={"col-3"}>
                <OwLabel title={"vendor"} isSupplierVendorOverride={true} supplierModel={supplierModel} />
                <div>
                    <OwInputWrapper
                        name={"vendor"}
                        placeholder={"vendor"}
                        supplierModel={supplierModel}
                        isSupplierVendorOverride={true}
                        value={searchValues.vendor}
                        fn={handleChange}
                        onKeyDownFn={enterSearch}
                    />
                </div>
            </div>

            <div className={"col-3"}>
                <OwLabel title={"name"} />
                <div>
                    <OwInputWrapper name={"name"} placeholder={"name"} value={searchValues.name} fn={handleChange} onKeyDownFn={enterSearch} />
                </div>
            </div>

            <div className={"col-3"}>
                <OwLabel title={"email"} />
                <div>
                    <OwInputWrapper name={"email"} placeholder={"email"} value={searchValues.email} fn={handleChange} onKeyDownFn={enterSearch} />
                </div>
            </div>

            <div className={"col-3 d-flex"}>
                <OwButton title={"search"} fn={performSearch} />

                <div className={"ms-2"}>
                    <OwButton title={"reset"} fn={resetSearch} className={"btn-danger"} />
                </div>
            </div>
        </div>
    );
};
